import { AccountBalanceOutlined, CalendarMonthOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { Event } from '../../../types/Event';
import { UserConfigurableModule } from '../../../types/User';
import { humanizeEventDateTimes } from '../../../utility/dateUtils';
import DrawerLink from '../../common/drawers/ModuleDrawer/DrawerLink';
import {
  secondaryIconStyles,
  secondaryLabelStyles,
  secondaryTextStyles,
  textContainerStyles,
  tileContainerStyles,
  tileHeaderLeftStyles,
  tileHeaderSectionStyles,
  tileSectionLeftStyles,
} from '../dashboardStyles';

export function EventTile(event: Event) {
  const dateLabel = humanizeEventDateTimes(event);
  return (
    <Box key={event.uuid} sx={tileContainerStyles}>
      <Box sx={tileSectionLeftStyles}>
        <Box sx={tileHeaderSectionStyles}>
          <DrawerLink module={UserConfigurableModule.EVENTS} uuid={event.uuid}>
            <Typography title={event.name} sx={tileHeaderLeftStyles}>
              {event.name}
            </Typography>
          </DrawerLink>
        </Box>
        <Box sx={textContainerStyles}>
          <Box sx={secondaryTextStyles}>
            <CalendarMonthOutlined sx={secondaryIconStyles} />
            <Typography title={dateLabel} sx={{ ...secondaryLabelStyles, textDecoration: 'none' }}>{dateLabel}</Typography>
          </Box>
          <Box sx={secondaryTextStyles}>
            <AccountBalanceOutlined sx={secondaryIconStyles} />
            <DrawerLink module={UserConfigurableModule.ACCOUNTS} uuid={event.account_uuid}>
              <Typography title={event.account_display_name} sx={secondaryLabelStyles}>{event.account_display_name}</Typography>
            </DrawerLink>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
